<div class="main-wrapper">
  <app-sidebar *ngIf="show"></app-sidebar>
  <!-- <app-sticky-icons></app-sticky-icons> -->
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>
